import axios from "axios";
import settings from "../settings";
import router from "../router";

let initialState = {
    loadingNotificationCenterList: false,
    loadingNotificationCenterData: false,
    requestSuccess: false,
    requestError: false,
    drawerOpen: false,
    notifications: [],
    activeNotification: {},
    errorMessage: "",
    tableOptions: null
};
export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async getNotificationsList({ commit }) {
            commit("setNotificationCenterListLoading", true);
            commit("setRequestSuccess", false);
            try {
                let response = await axios.get(settings.api_url + "/notifications-center/");
                if (response.status === 200 && response.data && response.data.success === 1) {
                    commit("addNotifications", response.data.notifications);
                }
            } catch (e) {
                console.log(e);
            }
            commit("setNotificationCenterListLoading", false);
        },
        async getNotificationData({ commit }, payload) {
            commit("setRequestSuccess", false);
            commit("setNotificationCenterDataLoading", true);
            try {
                let response = await axios.get(
                    `${settings.api_url}/notification-center/?invoice_id=${payload.id}&type=${payload.type}`
                );
                if (response && response.data && response.data.success === 1) {
                    commit("setActiveNotification", response.data.notification_data);
                }
            } catch (e) {
                console.log(e);
            }
            commit("setNotificationCenterDataLoading", false);
        }
    },
    mutations: {
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        addNotifications(state, notifications) {
            state.notifications = notifications;
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        setNotificationCenterListLoading(state, value) {
            state.loadingNotificationCenterList = value;
        },
        setNotificationCenterDataLoading(state, value) {
            state.loadingNotificationCenterData = value;
        },
        setActiveNotification(state, notification) {
            state.activeNotification = notification;
        },
        updateNotificationProperty(state, { prop, value }) {
            state.activeNotification = {
                ...state.activeNotification,
                [prop]: value
            };
        },
        resetActiveNotificationData(state) {
            state.activeNotification = null;
        }
    },
    getters: {}
};
